<template>
  <AdminLayout>
    <router-view />
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/components/AdminLayout.vue'

export default {
  name: 'AdminLayoutWrapper',
  components: {
    AdminLayout
  }
}
</script> 